import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CardModule} from 'primeng/card';

@Component({
  selector: 'app-card-with-header',
  standalone: true,
  imports: [CommonModule, CardModule],
  templateUrl: './card-with-header.component.html',
  styleUrl: './card-with-header.component.scss',
  host: {
    'class': 'flex flex-col w-full flex-grow min-h-0'
  }
})
export class CardWithHeaderComponent {
  @Input() usedWithTabs: boolean = false
  @Input() hasHeader: boolean = true
  @Input() hasFooter:boolean = false
}
